/**
 * @author      sam@zumper.com (Sam Sherman)
 * @copyright   Copyright (c) 2018, Zumper
 * @description toTitleCase
 */

import { capitalize } from '@zcode/utils'
export type { TitleCase } from '@zcode/utils'

export default capitalize
